<form #form="ngForm" class="login-form">
  <mat-form-field appearance="outline" [class.error-margin]="inputEmpresa.touched && inputEmpresa?.errors">
    <mat-label>Empresa</mat-label>
    <input 
      matInput 
      name="inputEmpresa"
      #inputEmpresa="ngModel"
      [(ngModel)]="colaborador.empresa"
      mascara="99"
      type="text"
      class="custom-input"
      placeholder="Empresa" 
      autocomplete="off"
      required
      (focus)="setFocus('inputEmpresa')"
      (blur)="removeFocus('inputEmpresa')">
      <button
        *ngIf="(hasFocus('inputEmpresa') || hasFocus('cancel-inputEmpresa')) && inputEmpresa.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputEmpresa')"
        (mouseleave)="removeFocus('cancel-inputEmpresa')"
        (click)="clearField(inputEmpresa.control,'cancel-inputEmpresa')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputEmpresa.touched && inputEmpresa.errors">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe o número da empresa
      </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" [class.error-margin]="inputFilial.touched && inputFilial?.errors">
    <mat-label>Filial</mat-label>
    <input 
      matInput 
      name="inputFilial"
      #inputFilial="ngModel"
      [(ngModel)]="colaborador.filial"
      mascara="9999"
      type="text"
      placeholder="Filial" 
      autocomplete="off"
      required
      (focus)="setFocus('inputFilial')"
      (blur)="removeFocus('inputFilial')">
      <button
        *ngIf="(hasFocus('inputFilial') || hasFocus('cancel-inputFilial')) && inputFilial.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputFilial')"
        (mouseleave)="removeFocus('cancel-inputFilial')"
        (click)="clearField(inputFilial.control,'cancel-inputFilial')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputFilial.touched && inputFilial.errors">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe o número da filial
      </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" [class.error-margin]="inputTafil.touched && inputTafil?.errors">
    <mat-label>Tipo de atividade</mat-label>
    <input 
      matInput 
      name="inputTafil"
      #inputTafil="ngModel"
      [(ngModel)]="colaborador.tafil"
      type="text"
      mascara="S"
      placeholder="Tipo de atividade" 
      autocomplete="off"
      required
      (focus)="setFocus('inputTafil')"
      (blur)="removeFocus('inputTafil')">
      <button
        *ngIf="(hasFocus('inputTafil') || hasFocus('cancel-inputTafil')) && inputTafil.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputTafil')"
        (mouseleave)="removeFocus('cancel-inputTafil')"
        (click)="clearField(inputTafil.control,'cancel-inputTafil')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputTafil.touched && inputTafil.errors">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe o tipo de atividade
      </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" [class.error-margin]="inputMatricula.touched && inputMatricula?.errors">
    <mat-label>Matrícula</mat-label>
    <input
      matInput 
      name="inputMatricula"
      #inputMatricula="ngModel"
      [(ngModel)]="colaborador.matricula"
      mascara="9999999999"
      placeholder="Matrícula"
      type="text"
      autocomplete="off"
      required
      minlength="10"
      (focus)="setFocus('inputMatricula')"
      (blur)="removeFocus('inputMatricula')">
      <button
        *ngIf="(hasFocus('inputMatricula') || hasFocus('cancel-inputMatricula')) && inputMatricula.control.value?.length > 0" 
        mat-icon-button 
        matSuffix
        class="cancel-icon"
        type="button"
        (mouseover)="setFocus('cancel-inputMatricula')"
        (mouseleave)="removeFocus('cancel-inputMatricula')"
        (click)="clearField(inputMatricula.control,'cancel-inputMatricula')">
        <mat-icon >cancel</mat-icon>
      </button>
      <mat-error *ngIf="inputMatricula.touched && inputMatricula.hasError('minlength')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Deve ter 10 dígitos
      </mat-error>
      <mat-error *ngIf="inputMatricula.touched && inputMatricula.hasError('required')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe o número da matricula
      </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" [class.error-margin]="inputSenha.touched && inputSenha?.errors">
    <mat-label>Senha</mat-label>
    <input 
      matInput 
      name="inputSenha"
      #inputSenha="ngModel"
      [(ngModel)]="colaborador.senha"
      type="password"
      placeholder="Senha" 
      autocomplete="off"
      required
      [type]="showPassword ? 'text' : 'password'">
      <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showPassword">
        <mat-icon class="suffix-icon" matSuffix>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error *ngIf="inputSenha.touched && inputSenha.errors">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Informe a senha
      </mat-error>
  </mat-form-field>

  <button 
    type="submit"
    mat-flat-button
    [disabled]="form.invalid || loading"
    (click)="handleLogin()"
    class="continue-btn">
    <mat-icon *ngIf="loading">
      <mat-spinner color="primary" diameter="20">
      </mat-spinner>
    </mat-icon>
    Continuar
  </button>
</form>